import { ASSETS, Chapter, Reveal } from "../presentation";

export default function S03UAE() {
  return (
    <section id="uae" className="about-immersive theme-dark" data-testid="slide-uae">
      <div className="about-immersive-media media-right" data-testid="uae-media">
        <img src={ASSETS.rakShipyard} alt="Sunreef Yachts shipyard — UAE" data-testid="uae-photo" />
      </div>
      <div className="about-immersive-scrim" />
      <div className="about-immersive-grain" />

      <div className="about-immersive-inner">
        <div className="sec-topbar" style={{ marginBottom: 0 }}>
          <Chapter ch="03" label="u.a.e." testid="uae-chapter" />
          <span className="wordmark wordmark-sm">SUNREEF</span>
        </div>

        <div className="about-immersive-content">
          <Reveal><span className="eyebrow">.uae expansion</span></Reveal>
          <Reveal delay={1}>
            <h2 className="editorial editorial-lg" data-testid="uae-headline">
              A growing facility in <span className="gold">the UAE.</span>
            </h2>
          </Reveal>

          <Reveal className="hairline-list" as="ol" delay={2} testid="uae-list">
            <li data-testid="uae-item-01">
              <span className="num">.01</span>
              <span className="content">
                Ultima &amp; Next projects
                <span className="content-body">A dedicated shed for the Ultima and Next production lines.</span>
              </span>
            </li>
            <li data-testid="uae-item-02">
              <span className="num">.02</span>
              <span className="content">
                Accommodation facility
                <span className="content-body">A new facility housing the growing UAE team.</span>
              </span>
            </li>
          </Reveal>

          <Reveal className="stat-row" delay={3} testid="uae-stats">
            <div className="stat">
              <span className="stat-num">1,400</span>
              <span className="stat-label">.people employed</span>
            </div>
            <div className="stat">
              <span className="stat-num">4</span>
              <span className="stat-label">.production sheds completing</span>
            </div>
            <div className="stat">
              <span className="stat-num">50,000<span className="stat-unit">m²</span></span>
              <span className="stat-label">.uae production area</span>
            </div>
            <div className="stat">
              <span className="stat-num">15,000<span className="stat-unit">m²</span></span>
              <span className="stat-label">.uae workshop facility</span>
            </div>
          </Reveal>
        </div>

        <div className="about-immersive-foot">
          <span className="about-caption about-caption-corner" data-testid="uae-caption">.shipyard in the united arab emirates</span>
        </div>
      </div>
    </section>
  );
}
